// imports
import _get from 'lodash/get';

import BinPointModel from '$models/monitoring/BinPointModel';
import MMCollection from '../MMCollection';

// class definition
export default class ProjectCollection extends MMCollection {
	// constructor
	constructor(args = {}) {
		// clone args to do some modifications
		args = Object.assign({}, args);
		args.Model = args.Model || BinPointModel;
		
		// call super constructor
		super(args);
	}
}
